module.exports = __webpack_public_path__ + "img/4e304b6d3660b99ac494c93ff4da017e.png";